import { Link } from "react-router-dom";

const Success = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h2>🎉 Subscription Successful!</h2>
      <p>Thank you for subscribing to PrivateIQ. You now have full access to the platform.</p>
      <Link to="/courses" style={{ textDecoration: "none", color: "#007bff", fontSize: "18px" }}>
        Explore
      </Link>
    </div>
  );
};

export default Success;
